import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useMessaging, useDictionary } from "@adamlip/okeoke.client";

export default function Article() {
  const { id } = useParams();
  const { articles } = useMessaging();
  const { getValue } = useDictionary();
  const navigate = useNavigate();

  const [article, setArcticle] = useState(null);

  const handleClickLink = () => {
    window.open(article?.attributes?.externalLink);
  };

  useEffect(() => {
    if (articles) {
      setArcticle(articles?.filter((article) => article.uid === id)?.[0]);
    }
    //eslint-disable-next-line
  }, [articles]);

  if (!article)
    return (
      <div className="w-full p-3 text-center">
        {getValue("app_v2_newsfeed_no_article_found")}.
      </div>
    );

  return (
    <div className="p-2 h-full overflow-hidden flex flex-col relative">
      <div className="flex-grow overflow-auto pb-96">
        <div className="font-bold text-xl mb-2 pr-[76px]">
          {article.subject}
        </div>
        <div className="">{article.message}</div>
        {article?.attributes?.externalLink &&
          article?.attributes?.externalLinkLabel && (
            <div
              className="p-2 bg-[var(--button-bg-color)] truncate mt-2 mx-auto text-center"
              onClick={handleClickLink}
              style={{
                borderRadius: "var(--general-button-border-radius)",
              }}
            >
              {article?.attributes?.externalLinkLabel}
            </div>
          )}
      </div>
      <div className="absolute right-1 top-1  flex">
        <div
          className="btn m-0"
          onClick={() => navigate(`/newsfeed/all/${article.uid}`)}
        >
          {getValue("app_v2_newsfeed_back")}
        </div>
      </div>
    </div>
  );
}
